import config from './config';

declare let __webpack_public_path__: string;

// eslint-disable-next-line @typescript-eslint/no-unused-vars, prefer-const
__webpack_public_path__ = config.publicPath;
